import { AdminReportsTable } from "../adminReportsTable/adminReportsTable.component";

export const AdminReports = () => {
  return (
    <AdminReportsTable />
  )
};
